const Record = ({ color = 'white' }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2C6.48615 2 2 6.48615 2 12C2 17.5139 6.48615 22 12 22C17.5139 22 22 17.5139 22 12C22 6.48615 17.5139 2 12 2ZM12 3.5C16.7031 3.5 20.5 7.29685 20.5 12C20.5 16.7031 16.7031 20.5 12 20.5C7.29685 20.5 3.5 16.7031 3.5 12C3.5 7.29685 7.29685 3.5 12 3.5ZM12 7.5C9.5236 7.5 7.5 9.5236 7.5 12C7.5 14.4764 9.5236 16.5 12 16.5C14.4764 16.5 16.5 14.4764 16.5 12C16.5 9.5236 14.4764 7.5 12 7.5Z" fill="white"/>
</svg>
)

export default Record
